import { publicApi } from "@/lib/axios/instances";
import { Cart, AddToCartDto, CartItem } from "@/types/cart";

export const fetchCart = async (bonusesUsed?: number): Promise<Cart> => {
  const { data } = await publicApi.get<Cart>(`/cart?bonusesUsed=${bonusesUsed}`);
  return data;
}

export const addToCartRequest = async (dto: AddToCartDto): Promise<CartItem> => {
  const { data } = await publicApi.post<CartItem>('/cart', dto);
  return data;
}

export const removeFromCartRequest = async (cartItemId: CartItem['id']): Promise<CartItem> => {
  const { data } = await publicApi.delete<CartItem>(`/cart/${cartItemId}`);
  return data;
}

export const incrementCartItemRequest = async (cartItemId: CartItem['id']): Promise<CartItem> => {
  const { data } = await publicApi.patch<CartItem>(`/cart/increment/${cartItemId}`);
  return data;
}

export const decrementCartItemRequest = async (cartItemId: CartItem['id']): Promise<CartItem> => {
  const { data } = await publicApi.patch<CartItem>(`/cart/decrement/${cartItemId}`);
  return data;
}